import { getBuyerId, getGuestId, getUserType } from 'dibs-cookie-jar';
import { type FC, useState, useEffect, useCallback, useRef } from 'react';
import { CUSTOMER_TYPE_TRADE } from 'dibs-buyer-layout/exports/userStorageConstants';
import { getUserSessionCountryCode } from 'dibs-regional-info/src/regionalInfoHelpers';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

// components
import { SellerReviewInformationLoading } from 'dibs-seller-reviews-modal';
import VisibilityTracker from 'dibs-visibility-tracker/exports/VisibilityTracker';
import { PdpRespMarketplaceLayoutSecondary } from './PdpRespMarketplaceLayoutSecondary';
import { PdpRespMarketplaceLoadingCarousel } from '../PdpRespMarketplaceLoadingCarousel/PdpRespMarketplaceLoadingCarousel';

// types
import { type pdpRespMarketplaceSecondaryRootQuery$variables as SecondaryRelayVariables } from '../../../queries/pdpRespMarketplaceSecondaryRoot';

export const PdpRespMarketplaceLayoutSecondaryRenderer: FC<{
    ssr: boolean;
    relayVariables: SecondaryRelayVariables;
}> = ({ ssr, relayVariables: serverRelayVariables }) => {
    const relayVariables = useRef(serverRelayVariables);
    const layoutVisibilityRef = useRef<HTMLDivElement>(null);
    const { isBotDetected, isPdpSellerReviewsVariant } = useServerVarsContext();
    const [shouldRenderAfterDisplay, setShouldRenderAfterDisplay] = useState(false);

    useEffect(() => {
        const userId = getBuyerId(document.cookie) || '';
        const userType = getUserType(document.cookie);
        const guestId = getGuestId(document.cookie) || '';
        const userCountryCode = getUserSessionCountryCode();
        relayVariables.current = {
            ...serverRelayVariables,
            userId,
            guestId,
            afterDisplay: true,
            afterDisplayAndNotBot: !isBotDetected,
            fetchUser: !!userId,
            isTrade: userType === CUSTOMER_TYPE_TRADE,
            userCountryCode,
            fetchSellerReviewsSection: !!isPdpSellerReviewsVariant,
        };
    }, [isBotDetected, serverRelayVariables, isPdpSellerReviewsVariant]);

    const scrollHandler = useCallback(() => setShouldRenderAfterDisplay(true), []);
    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, [scrollHandler]);

    useEffect(() => {
        if (shouldRenderAfterDisplay) {
            window.removeEventListener('scroll', scrollHandler);
        }
    }, [shouldRenderAfterDisplay, scrollHandler]);

    return (
        <>
            <VisibilityTracker
                elementRef={layoutVisibilityRef}
                onVisibilityChange={({ isVisible }) =>
                    isVisible && setShouldRenderAfterDisplay(true)
                }
            />
            <div ref={layoutVisibilityRef} />
            {ssr || shouldRenderAfterDisplay ? (
                <>
                    <PdpRespMarketplaceLayoutSecondary
                        relayVariables={relayVariables.current}
                        afterDisplay={shouldRenderAfterDisplay}
                    />
                </>
            ) : (
                <>
                    {isPdpSellerReviewsVariant && <SellerReviewInformationLoading />}
                    {[1, 1].map((_, index) => (
                        <PdpRespMarketplaceLoadingCarousel key={index} />
                    ))}
                </>
            )}
        </>
    );
};
